module.exports = __webpack_public_path__ + "static/media/Footer.e5d2d4e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Footer.svg
// module id = 418
// module chunks = 1